export enum PricingEditField {
  GrossMarginPercentage = 'GROSS_MARGIN_PERCENTAGE',
  Price = 'PRICE',
}

export interface PricingInvoiceHistoryEntry {
  grossMarginPercentage: number | null;
  invoiceDate: string;
  priceInMicros: number | null;
  quantity: number;
}

export interface PricingEdit {
  grossMarginPercentage: number;
  grossMarginPercentageDelta: number;
  grossProfitDeltaInMicros: number;
  grossProfitImpactInMicros: number;
  grossProfitInMicros: number;
  priceDeltaInMicros: number;
  priceInMicros: number;
  restaurantUUID: string;
  supplierUUID: string;
  updatedField: PricingEditField;
  variantPackUUID: string;
  weeklyVolume: number;
}

export enum GrossMarginEditAction {
  AddAmount = 'ADD_AMOUNT_GROSS_MARGIN',
  AddOnePercent = 'ADD_ONE_PERCENT',
  SetAmount = 'SET_AMOUNT_GROSS_MARGIN',
  SetLastMargin = 'SET_LAST_MARGIN',
  SubtractOnePercent = 'SUBTRACT_ONE_PERCENT',
}

export enum PriceEditAction {
  AddAmount = 'ADD_AMOUNT_PRICE',
  EndInX9 = 'END_IN_X9',
  RandomRoundUp = 'RANDOM_ROUND_UP',
  SetAmount = 'SET_AMOUNT_PRICE',
  SetLastPrice = 'SET_LAST_PRICE',
}

export enum RevertEditAction {
  RevertEdit = 'REVERT_EDIT',
}

export enum BookmarkAction {
  Bookmark = 'BOOKMARK',
  Unbookmark = 'UNBOOKMARK',
}

export type PriceEditActionType =
  | GrossMarginEditAction
  | PriceEditAction
  | RevertEditAction;

export enum EditScopeKind {
  Bookmarked = 'bookmarked',
  Restaurant = 'restaurant',
  Review = 'review',
  VariantPack = 'variantPack',
}

export type EditScope =
  | { kind: EditScopeKind.Bookmarked }
  | { kind: EditScopeKind.Restaurant; uuid: string }
  | { kind: EditScopeKind.Review }
  | { kind: EditScopeKind.VariantPack; uuid: string };

export interface PricingEditsState {
  edits: PricingEdit[];
  editSnapshotStack: Record<string, PricingEdit[][]>; // keyed by serialized EditScope
  expiredEditsCount: number;
  initialEdits: PricingEdit[];
  supplierTimezone: string;
  validUntil?: string;
}

export interface PricingEditsActions {
  applyEdits: (edits: PricingEdit[], scope: EditScope) => void;
  resetUndoHistory: (scope: EditScope) => void;
  revertAllEdits: () => void;
  revertEditsByRestaurant: (
    restaurantUUID: string,
    variantPackUUIDs: string[],
    scope: EditScope,
  ) => void;
  revertEditsByVariantPack: (
    variantPackUUID: string,
    restaurantUUIDs: string[],
    scope: EditScope,
  ) => void;
  setSupplierTimezone: (timezone: string) => void;
  undo: (scope: EditScope) => void;
}

export type PricingEditsStore = PricingEditsState & PricingEditsActions;
